import type React from 'react';
import { RootStoreProvider as LibRootStoreProvider } from '@intrasync/react';

import type RootStore from '../../stores/RootStore';

interface RootStoreProviderProps {
  rootStore: RootStore;
  children: React.ReactNode;
}

/**
 * Thin adapter over @intrasync/react's RootStoreProvider.
 *
 * Runtime behaviour is identical (<Provider rootStore={rootStore} {...rootStore}>
 * wrapping a <div ref>). The cast is only needed because the library types its
 * `rootStore` prop against its own compat RootStore stub, which this app's
 * concrete RootStore is not structurally assignable to.
 */
const RootStoreProvider =
  LibRootStoreProvider as unknown as React.ForwardRefExoticComponent<
    RootStoreProviderProps & React.RefAttributes<HTMLDivElement>
  >;

export default RootStoreProvider;
